import authAxios from "../common/authAxios";

class DormContract {
    getAll() {
        return authAxios.get("/application/contract/all");
    }

    canApply() {
        return authAxios.get("/application/contract/abitur/can-apply");
    }

    approve(id, {
        approved,
        comment,
    }) {
        return authAxios.put(`/application/contract/approve?applicationId=${id}`,
            {
                approved,
                comment,
            }
        );
    }

    getAllForAbitur() {
        return authAxios.get(`/application/contract/abitur`);
    }

    uploadPaymentCheck(file) {
        const formData = new FormData();
        formData.append("paymentFile", file);

        return authAxios.put(`/application/contract/abitur/payment-check`,
            formData
        );
    }

    signContract() {
        return authAxios.put(`/application/contract/abitur/sign`);
    }

    selectRoom(roomId) {
        return authAxios.put(`/application/contract/abitur/select-room?roomId=${roomId}`);
    }

    getDormitories() {
        return authAxios.get(`/application/contract/abitur/dormitory`);
    }

    getRooms(dormitoryId) {
        return authAxios.get(`/application/contract/abitur/rooms?dormitoryId=${dormitoryId}`);
    }

    createContract(dormDto) {
        return authAxios.post(`/application/contract/abitur/dormitory/contract`, dormDto);
    }

    sendContract2Podpishi(dormDto){
        return authAxios.post(`/application/contract/abitur/dormitory/contract/upload`, dormDto);
    }
}

export default DormContract;